import { render, staticRenderFns } from "./deleteTemplateDialog.vue?vue&type=template&id=45895d22&scoped=true&lang=pug"
import script from "./deleteTemplateDialog.vue?vue&type=script&lang=js"
export * from "./deleteTemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./deleteTemplateDialog.vue?vue&type=style&index=0&id=45895d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45895d22",
  null
  
)

export default component.exports